// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b0297d90","885":"bcfa9cc3","977":"7e57dcab"}[chunkId] + ".chunk.js";
};